
<app-common-header  [pagename]="page" [usermsg]="card_data" [loginuser]="login_response">
</app-common-header> 
<main  id="mm-apage-section"
  class="min-vh-100 device_{{device_type}}  app_device_{{device}}  device_app_ver_{{device_app_ver}} {{page+'_page_content'}} {{page+'_page_content'|common:'rmspace'}} {{''|common:'mainclass'}} {{apaid?'page-paid-user':'page-nonpaid-user'}} {{isLogin?'page-login':'page-non-login'}}">
  <div class="mojotimes-banner common-banner-head">
    <ng-template [ngIf]="device_type == 'desktop'" [ngIfElse]="adspotmob">
      <div id="ct_header" class="ct_pgname_header_web"></div>
    </ng-template>
    <ng-template #adspotmob>
      <div id="ct_header" class="ct_pgname_header_mob"></div>
    </ng-template>
  </div>
  <router-outlet ></router-outlet>
<!-- <router-outlet (activate)="onActive(page)"></router-outlet> -->
</main>

<app-stock-footer [cid]="34"></app-stock-footer>